const state = {
    currentJob: null,
    currentApplication: null,
};

const mutations = {
    updateJob(nextState, currentJob) {
        nextState.currentJob = currentJob;
    },
    updateApplication(nextState, currentApplication) {
        nextState.currentApplication = currentApplication;
    },
};

const actions = {
    setCurrentJob: (context, job) => context.commit('updateJob', job),
    removeCurrentJob: (context) => context.commit('updateJob', null),
    setCurrentApplication: (context, application) => context.commit('updateApplication', application),
    removeCurrentApplication: (context) => context.commit('updateApplication', null),
};

export default {
    state,
    actions,
    mutations,
};
